import * as React from "react";
import { useEffect, useReducer } from 'react';
import { Spinner, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import InfiniteScroll from 'react-infinite-scroller';
import * as Models from '../models';
import { ResourcesService, SearchIn } from '../services/ResourcesService';
import classnames from 'classnames';

const PAGE_SIZE = 10;

class SearchType extends Models.LookupItem {
    ListingTitle: string;
}

type Props = {
    blogCategories: Models.LookupItem[];
    blogCountries: Models.LookupItem[];
    caseStudyCategories: Models.LookupItem[];
    caseStudyCountries: Models.LookupItem[];
    deafultSearchType: string;
    caseStudiesTreeOrder: boolean;
    addPodcastLink: boolean;
    hideOtherResourceTypes: boolean;
    showCountriesFilter: boolean;
    culture: string;
}
type ResourcesPageState = {
    searchBy: SearchType;
    keywords: string;
    category: Models.LookupItem;
    country: Models.LookupItem;
    canLoadMore: boolean;
    isLoading: boolean;
    items: Models.ResourceItem[];
    totalItems: number;
    lastFilter: SearchIn
    lastSearchBy: SearchType;
    searchTrigger: number;
}

const searchTypes: SearchType[] = [{ title: "All", value: '', ListingTitle: 'All Articles' },
{ title: "Blog", value: 'blog', ListingTitle: 'Blog' },
{ title: "Case Studies", value: 'casestudies', ListingTitle: 'Case Studies' }];

const initialState: ResourcesPageState = {
    searchBy: searchTypes[0],
    keywords: '',
    category: undefined,
    country: undefined,
    canLoadMore: false,
    isLoading: false,
    items: [],
    totalItems: 0,
    lastFilter: undefined,
    lastSearchBy: searchTypes[0],
    searchTrigger: 0
}


const ResourcesPage = (props: Props) => {

    const getInitialState = () => {
        var defaultSearchType = searchTypes.find((x) => x.value == (props.deafultSearchType || ''));

        let result = initialState;

        if (defaultSearchType) {
            result.searchBy = defaultSearchType;
        }

        return result;
    };

    const [state, setState] = useReducer(
        (prevState: ResourcesPageState, newState: Partial<ResourcesPageState>) => ({ ...prevState, ...newState }),
        getInitialState()
    );

    const search = async () => {

        const lastFilter: SearchIn = {
            keywords: state.keywords,
            category: state.category ? state.category.value : '',
            country: state.country ? state.country.value : '',
            searchBy: state.searchBy.value,
            caseStudiesTreeOrder: props.caseStudiesTreeOrder,
            culture: props.culture
        };

        setState({
            isLoading: true,
            lastFilter: lastFilter,
            //items: [],
            lastSearchBy: state.searchBy
        });

        const result = await ResourcesService.search(lastFilter, PAGE_SIZE, 0);

        if (!result.hasErrors) {
            setState({
                items: result.value.items,
                totalItems: result.value.totalItems,
                isLoading: false,
                canLoadMore: result.value.totalItems > result.value.items.length
            })
        }
    }

    const loadMore = async () => {

        setState({
            isLoading: true
        });

        const result = await ResourcesService.search(state.lastFilter, PAGE_SIZE, state.items.length);

        if (!result.hasErrors) {

            const newItemsSet = state.items.concat(result.value.items);

            setState({
                items: newItemsSet,
                totalItems: result.value.totalItems,
                isLoading: false,
                canLoadMore: result.value.totalItems > newItemsSet.length
            })
        }

    }

    useEffect(() => {

        if (!state.category) {
            setState({ searchTrigger: state.searchTrigger + 1 });
            return;
        }

        if (!state.country) {
            setState({ searchTrigger: state.searchTrigger + 1 });
            return;
        }

        if (state.searchBy.value == 'blog') {
            if (!props.blogCategories.find(x => x.value == state.category.value)) {
                setState({
                    category: undefined,
                    searchTrigger: state.searchTrigger + 1
                });
            }
            if (!props.blogCountries.find(x => x.value == state.country.value)) {
                setState({
                    country: undefined,
                    searchTrigger: state.searchTrigger + 1
                });
            }
        } else if (state.searchBy.value == 'casestudies') {
            if (!props.caseStudyCategories.find(x => x.value == state.category.value)) {
                setState({
                    category: undefined,
                    searchTrigger: state.searchTrigger + 1
                });
            }
            if (!props.caseStudyCountries.find(x => x.value == state.country.value)) {
                setState({
                    country: undefined,
                    searchTrigger: state.searchTrigger + 1
                });
            }
        } else {
            setState({
                category: undefined,
                country: undefined,
                searchTrigger: state.searchTrigger + 1
            });
        }

    }, [state.searchBy]);

    useEffect(() => {

        search();

    }, [state.searchTrigger, state.category, state.country])


    useEffect(() => {

        search();

    }, []);

    return (
        <>
            <div className="container mb-3">
                <div className="row">
                    <div className="col">
                        {!props.hideOtherResourceTypes && <div>
                            <ul className="nav nav-pills">
                                {searchTypes.map(x => <li className="nav-item" key={x.title}>
                                    <a className={classnames({ 'nav-link': true, 'active': state.searchBy.value == x.value })}
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setState({ searchBy: x })
                                        }}
                                    >{x.title}</a>
                                </li>)}

                                {props.addPodcastLink == true &&
                                    <li className="nav-item" key="podcast">
                                        <a className="nav-link" href="/podcast">
                                            Podcast
                                        </a>
                                    </li>
                                }
                            </ul>
                        </div>}
                        <form className="row align-items-end listing-filters">
                            <div className="col-lg-auto col-sm-6 pe-0 mb-3">
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-auto">
                                            <label>Categories</label>
                                            <UncontrolledDropdown>
                                                <DropdownToggle>
                                                    {state.category ? state.category.title : 'All Categories'}
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    {state.category
                                                        && <DropdownItem onClick={() => { setState({ category: undefined }) }}>All Categories</DropdownItem>}

                                                    {(state.searchBy.value == '' || state.searchBy.value == 'blog')
                                                        && <DropdownItem header>Blog</DropdownItem>}
                                                    {(state.searchBy.value == '' || state.searchBy.value == 'blog')
                                                        && props.blogCategories.map(x => <DropdownItem key={x.value} onClick={() => { setState({ category: x }) }} {...{ active: state.category && (x.value == state.category.value) }}>{x.title}</DropdownItem>)}

                                                    {(state.searchBy.value == '' || state.searchBy.value == 'casestudies')
                                                        && <DropdownItem header>Case Studies</DropdownItem>}
                                                    {(state.searchBy.value == '' || state.searchBy.value == 'casestudies')
                                                        && props.caseStudyCategories.map(x => <DropdownItem key={x.value} onClick={() => { setState({ category: x }) }} {...{ active: state.category && (x.value == state.category.value) }}>{x.title}</DropdownItem>)}
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        </div>
                                        {props.showCountriesFilter && (
                                            <div className="col-md-auto">
                                                <label>Countries</label>
                                                <UncontrolledDropdown>
                                                    <DropdownToggle>
                                                        {state.country ? state.country.title : 'All Countries'}
                                                    </DropdownToggle>
                                                    <DropdownMenu>
                                                        {state.country
                                                            && <DropdownItem onClick={() => { setState({ country: undefined }) }}>All Countries</DropdownItem>}

                                                        {(state.searchBy.value == '' || state.searchBy.value == 'blog')
                                                            && <DropdownItem header>Blog</DropdownItem>}
                                                        {(state.searchBy.value == '' || state.searchBy.value == 'blog')
                                                            && props.blogCountries.map(x => <DropdownItem key={x.value} onClick={() => { setState({ country: x }) }} {...{ active: state.country && (x.value == state.country.value) }}>{x.title}</DropdownItem>)}

                                                        {(state.searchBy.value == '' || state.searchBy.value == 'casestudies')
                                                            && props.caseStudyCountries.map(x => <DropdownItem key={x.value} onClick={() => { setState({ country: x }) }} {...{ active: state.country && (x.value == state.country.value) }}>{x.title}</DropdownItem>)}
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                            </div>)}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-auto col-sm-6 pe-0 mb-3">
                                <div className="form-group">
                                    <label>Search</label>
                                    <input type="text" onChange={(e) => { setState({ keywords: e.target.value }) }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                search();
                                            }
                                        }}
                                        placeholder="Keywords Search" className="form-control" /></div>
                            </div>
                            <div className="col-auto col-xs-12 mb-3 pe-0">
                                <div className="form-group mt-lg-3" ><button type="button" className="btn btn-primary d-block w-100" onClick={search}>Search</button></div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="bg-grey pb-1">
                <div className="container">
                    {!props.hideOtherResourceTypes && <div className="row">
                        <div className="col">
                            <h3 className="pt-3">
                                {state.lastSearchBy.ListingTitle}
                            </h3>
                        </div>
                    </div>}
                    <InfiniteScroll
                        pageStart={0}
                        loadMore={loadMore}
                        hasMore={state.canLoadMore && !state.isLoading}
                        useWindow={true}
                        className="row row-cols-1 row-cols-sm-2 row-cols-md-3 cards-wrapper pt-3"
                    >
                        {state.items.map(item => {

                            return <div className="col" key={item.nodeId}> <a className="card card-scale-transition w-100 mb-4" href={item.url}>
                                {item.thumbnail && <div className="image-container" style={{ backgroundImage: "url('" + item.thumbnail + "')" }} ></div>}
                                {item.thumbnail && <img className="card-img-top" src={item.thumbnail} alt={item.thumbnailTitle} />}
                                <div className="card-body d-flex flex-column">
                                    {item.category && <div className="type-pill gold d-inline-flex align-items-center">{item.category.title}</div>}
                                    <h5 className="card-title" dangerouslySetInnerHTML={{ __html: item.title }}></h5>
                                    <div className="mt-auto card-bottom d-flex justify-content-between">
                                        {item.url && item.url.indexOf('case-studies') < 0 && !item.hideDate && <div>{item.date}</div>}
                                        {item.location && <div>{item.location}</div>}
                                    </div>
                                </div>
                            </a>
                            </div>
                        })}
                    </InfiniteScroll>
                    {!state.isLoading && state.items.length == 0 && <div className="listing-no-items-found">
                        Sorry.  There are no items matching your search criteria.
                    </div>}
                    <div className="text-center" style={{
                        marginTop: "-12px",
                        height: "45px"
                    }}>
                        {state.isLoading &&
                            <Spinner color="primary" />
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default ResourcesPage;